import React from "react";
import { Box, Container } from "@mui/material";

const ContactMapSection = () => {
  return (
    <>
      <style>{`
        .map-section {
          padding: 50px 0;
          background: #ffffff;
        }

        .map-wrapper {
          position: relative;
          width: 100%;
          height: 520px;
          border-radius: 24px;
          overflow: hidden;
          box-shadow: 0 30px 80px rgba(0, 0, 0, 0.15);
        }

        .map-wrapper iframe {
          width: 100%;
          height: 100%;
          border: 0;
          filter: grayscale(20%) contrast(1.05);
        }

        @media (max-width: 900px) {
          .map-wrapper {
            height: 380px;
            border-radius: 18px;
          }
        }

        @media (max-width: 600px) {
          .map-section {
            padding: 70px 0;
          }
          .map-wrapper {
            height: 320px;
            border-radius: 16px;
          }
        }
      `}</style>

      <Box className="map-section">
        <Box>
          <Box className="map-wrapper">
            <iframe
              title="Bloomington Indiana Map"
              loading="lazy"
              allowFullScreen
              referrerPolicy="no-referrer-when-downgrade"
              src="https://www.google.com/maps?q=Bloomington%20Indiana&output=embed"
            />
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default ContactMapSection;
